import React, { useContext, useEffect, useRef, useState } from 'react'
import logo1 from "../../Assests/mainLogo.png"
import mainLogo from "../../Assests/mainLogo.png"
import phoneIcon from "../../Assests/phone.svg"
import phoneIconBlack from "../../Assests/phoneBlack.svg"
import { Link, useLocation } from 'react-router-dom'
import menuIcon from '../../Assests/menu.svg'
import menuIconWhite from '../../Assests/menu white.svg'
import { contextData } from '../../App'

// Pink announcement bar at the very top of the site. Set to true (and update the text) to show it again.
const SHOW_ANNOUNCEMENT_BAR = false;

function Header() {

  const {isScrolled, setIsScrolled} = useContext(contextData);
  const [isToggleMenuOpen, setIsToggleMenuOpen] = useState(false);
  const divRef = useRef();
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? 'text-[#E40F94] font-bold' : '';

  const handleToggleClick = () => {
    setIsToggleMenuOpen(!isToggleMenuOpen)
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed w-full z-50">

      {/* ── ANNOUNCEMENT BAR ── */}
      {SHOW_ANNOUNCEMENT_BAR && (
        <div className="bg-[#E40F94] text-white text-center py-2 px-4 text-[11px] font-bold tracking-[2.5px] uppercase">
          ✦ Enroll Now — Summer Camp 2026 ✦<br />✦ June 8–12 · Pearland, Texas ✦
        </div>
      )}

      {/* ── NAVBAR ── */}
      <div className={`w-full sm:px-[190px] px-4 ${isScrolled || isToggleMenuOpen ? 'bg-white shadow-md' : 'bg-black bg-opacity-60 rounded-b-2xl'}`}>
        <div className='flex items-center justify-between min-h-[104px]'>
          <div className='sm:block hidden'>
            <img src={isScrolled ? mainLogo : logo1} className='h-[77px] w-[80px]' alt="Chilanka Logo" />
          </div>
          <div className='sm:hidden block' onClick={handleToggleClick}>
            <img src={isScrolled ? menuIcon : menuIconWhite} alt="Menu" />
          </div>
          <div className={`sm:flex hidden gap-10 text-[16px] font-normal ${isScrolled ? 'text-[#383232]' : 'text-[#FFFFFF]'}`}>
            <Link to='/'><div className={`${isActive('/')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>Home</div></Link>
            <Link to='aboutPage'><div className={`${isActive('/aboutPage')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>About Us</div></Link>
            <Link to='classes'><div className={`${isActive('/classes')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>Classes</div></Link>
            <Link to='eventPage'><div className={`${isActive('/eventPage')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>Upcoming Events</div></Link>
            <Link to='galleryPage'><div className={`${isActive('/galleryPage')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>Gallery</div></Link>
            <Link to='fifaFanFestPage'><div className={`${isActive('/fifaFanFestPage')} relative after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:w-0 after:bg-[#E40F94] after:transition-all after:duration-300 hover:after:w-full hover:text-[#E40F94] transition-colors duration-300`}>⚽ FIFA World Cup 2026™ ⚽</div></Link>
          </div>
          <div className='flex gap-1 items-center justify-center'>
            <img src={isScrolled ? phoneIconBlack : phoneIcon} className='h-4 w-4' alt="Phone" />
            <div className={`text-[16px] font-normal hover:text-[#E40F94] cursor-pointer ${isScrolled ? 'text-[#383232]' : 'text-[#FFFFFF]'}`}>Call now: (469) 556-3040</div>
          </div>
        </div>

        {/* Mobile menu */}
        {isToggleMenuOpen && (
          <div className='flex flex-col gap-y-5 h-screen'>
            <Link to='/' onClick={handleToggleClick}><div>Home</div></Link>
            <Link to='aboutPage' onClick={handleToggleClick}><div>About Us</div></Link>
            <Link to='classes' onClick={handleToggleClick}><div>Classes</div></Link>
            <Link to='eventPage' onClick={handleToggleClick}><div>Upcoming Events</div></Link>
            <Link to='galleryPage' onClick={handleToggleClick}><div>Gallery</div></Link>
            <Link to='fifaFanFestPage' onClick={handleToggleClick}><div>⚽ FIFA World Cup 2026™ ⚽</div></Link>
          </div>
        )}
      </div>

    </div>
  )
}

export default Header